import React from 'react'

type VeryBadProps = {
  fill?: string
}

export const VeryBad = ({ fill = '#D82B39' }: VeryBadProps) => (
  <svg
    aria-label="Very bad"
    width="38"
    height="38"
    viewBox="0 0 38 38"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_114_1480)">
      <path
        d="M18.9841 3.16667C10.2441 3.16667 3.16663 10.26 3.16663 19C3.16663 27.74 10.2441 34.8333 18.9841 34.8333C27.74 34.8333 34.8333 27.74 34.8333 19C34.8333 10.26 27.74 3.16667 18.9841 3.16667ZM19 31.6667C12.0016 31.6667 6.33329 25.9983 6.33329 19C6.33329 12.0017 12.0016 6.33333 19 6.33333C25.9983 6.33333 31.6666 12.0017 31.6666 19C31.6666 25.9983 25.9983 31.6667 19 31.6667ZM24.5416 17.4167C25.8558 17.4167 26.9166 16.3558 26.9166 15.0417C26.9166 13.7275 25.8558 12.6667 24.5416 12.6667C23.2275 12.6667 22.1666 13.7275 22.1666 15.0417C22.1666 16.3558 23.2275 17.4167 24.5416 17.4167ZM13.4583 17.4167C14.7725 17.4167 15.8333 16.3558 15.8333 15.0417C15.8333 13.7275 14.7725 12.6667 13.4583 12.6667C12.1441 12.6667 11.0833 13.7275 11.0833 15.0417C11.0833 16.3558 12.1441 17.4167 13.4583 17.4167ZM19 21.375C15.3108 21.375 12.1758 23.6867 10.9091 26.9167H27.0908C25.8241 23.6867 22.6891 21.375 19 21.375Z"
        fill={fill}
      />
    </g>
    <defs>
      <clipPath id="clip0_114_1480">
        <rect width="38" height="38" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
